import { Avatar, Box, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
    backgroundColor: theme.palette.info.main,
    width: 32,
    height: 32,
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
    marginTop: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    width: 250,
    boxShadow: theme.shadows[3],
}));

export const StyledBox = styled(Box)({
    '& .MuiTypography-root': {
        maxWidth: 240,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
});

export const IconWrapper = styled('span')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1.5),
    color: '#707070',
}));
